import httpClient from '../base/httpClient';
import { PlaceOrderDto } from '../../interfaces/PlaceOrderDto';
import { PendingPlaceOrderDto } from '../../interfaces/PendingPlaceOrderDto';

export const PlaceOrderAPI = {
  getByCode: async (placeOrderCode: string) => {
    return await httpClient.get<PlaceOrderDto>(`/order/place-order/${placeOrderCode}`, {
      skipAuth: true,
    });
  },
  approve: async (placeOrderCode: string) => {
    return await httpClient.post<boolean>(`/order/place-order/${placeOrderCode}/approve`, null, {
      skipAuth: true,
    });
  },
  reject: async (placeOrderCode: string) => {
    return await httpClient.post<boolean>(`/order/place-order/${placeOrderCode}/reject`, null, {
      skipAuth: true,
    });
  },
  getPendingCount: async () => {
    return await httpClient.get<number>('/order/place-order/pending/count');
  },
  getPendingList: async () => {
    return await httpClient.get<PendingPlaceOrderDto[]>('/order/place-order/pending');
  },
};
